import { Component } from '@angular/core'
import { SharedService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-quotation-form',
  templateUrl: './quotation-form.component.html',
  styleUrls: ['./quotation-form.component.scss'],
})
export class QuotationFormComponent {
  formItemArray = new Array(10)
  public getImage =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-desktop-v5.png'
      : 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-desktop-en-v5.png'
  public getImageWebp =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-desktop-v5.webp'
      : 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-desktop-en-v5.webp'
  public getImageMobile =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-mobile-v5.png'
      : 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-mobile-en-v5.png'
  public getImageMobileWebp =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-mobile-v5.webp'
      : 'https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-form-mobile-en-v5.webp'
  public getAltText = this.translate.currentLang === 'th' ? 'ใบเสนอราคา' : 'quotation form'
  constructor(public translate: TranslateService, public sharedService: SharedService) {}

  displayFormText(no: string) {
    return `QUOTATION.SECTION_FEATURE.ITEM.TEXT_${no}`
  }
}
